import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends FeaturesBaseComponent  {
  year: number = new Date().getFullYear()
  environment = environment
  constructor() {
    super();
  }
  ngOnInit(): void {
  }

}
